import { styled } from 'styled-components';

export const TableCellPadding = styled.td`
  padding: 0;
`;

export const AccordionTableRowHeader = styled.table`
  width: 100% !important;
  border: 0 !important;

  &:focus {
    outline: none;
  }

  tbody {
    tr {
      :hover {
        td {
          background-color: initial !important;
        }
      }

      td:last-child {
        button {
          transition: transform
            ${({ theme }) => theme.animation.duration.default}
            ${({ theme }) => theme.animation.easing.moving};
          ${({ $isExpanded }) => $isExpanded && `transform: rotate(180deg)`};
        }
      }
    }
  }
`;
AccordionTableRowHeader.displayName = 'AccordionTableRowHeader';

export const AccordionTableRowBody = styled.div`
  width: 100%;
  transition: all ${({ theme }) => theme.animation.duration.slow}
    ${({ theme }) => theme.animation.easing.moving};
  overflow: hidden;

  ${({ $isExpanded }) => `
    min-height: ${$isExpanded ? '40px' : '0'};
    max-height: ${$isExpanded ? '2500px' : '0'};
  `}
`;
AccordionTableRowBody.displayName = 'AccordionTableRowBody';
